// extracted by mini-css-extract-plugin
module.exports = {"suggestedResults":"Search_suggestedResults__9kRBg","header":"Search_header__3BlqM","withSpacing":"Search_withSpacing__Ra0zC","notFound":"Search_notFound__fr__G"};